/* eslint-disable @typescript-eslint/no-explicit-any */
export const swap = <T extends any[]>(array: T, i1: number, i2: number): T => {
    const a = [...array];
    [a[i1], a[i2]] = [a[i2], a[i1]];
    return a as unknown as T;
};

export const areSame = (itemsIds: number[], sources: string[]): boolean => {
    const values = [];
    if (itemsIds.length === 1) {
        return false;
    }
    itemsIds.forEach((id, index) => {
        if (id) {
            values.push(sources[index]);
        }
    });
    return new Set(values).size === 1;
};

export const isEmpty = <T>(array: T[]): boolean => {
    const uniqueValues = array.filter(item => item);
    return uniqueValues.length === 0 || (uniqueValues.length === 1 && !uniqueValues[0]);
};

export const diff = (array1, array2) => array1.filter(el => !array2.includes(el));
